import React from "react";
import "./workdetail.css";
import img_front from "../../assets/papersing/front_face.jpg"
import img_side from "../../assets/papersing/side_face.jpg"

const Papersing = () => {
    return (   
        <section className="section">
            <div className="workdetail__container container">
                <img src={img_front} alt="front img" className="workdetail__img"></img>
                <img src={img_side} alt="side img" className="workdetail__img"></img>
                <div className="youtube_wrap">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/qGM1h-DuFDo?si=kuVMIKAjO-OvHYbb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
                <div className="workdetail__title">
                    <div className="eng">
                        Paper Sing
                    </div>
                    紙は鳴く
                </div>
                <div className="workdetail__caption">
                    <div className="eng">
                    This work is an interactive art that transforms the perception of human acts of destruction by converting the sound of paper being torn. Participants wear headphones and tear a sheet of paper. The sound of the paper tearing is converted in real time and fed back to the participant.

                    Humans perceive the world by connecting different forms of sensory information, such as vision, touch, and hearing. By altering the relationship between sound and touch in the familiar act of tearing paper, this work attempts to transform the impression of the act itself, as well as the participant’s bodily sensation.

                    Through cross-modal perceptual manipulation, the work explores how humans form meaning through their actions.

                    </div>
                    本作は、紙が破れる音を変換することで、人による破壊行為の知覚を変容させるインタラクティブ作品である。体験者はヘッドホンを装着し、紙を破る。紙が破れる音はリアルタイムに変換され、体験者へフィードバックされる。人は視覚・触覚・聴覚といった異なる感覚情報を結び付けながら世界を認識している。本作では、紙を破るという身近な行為に対して音と触覚の対応関係を変化させることで、行為そのものの印象や身体感覚の変容を試みた。クロスモーダルな知覚操作を通じて、人間がどのように行為の意味を形成しているのかを探る作品である。
                </div>
                <div className="workdetailitem__title">
                    Related Links
                </div>
                <div className="workdetail__credit">
                    Make: Japan | Hamamtsu Micro Maker Fair 2022 <a href="https://makezine.jp/event/makerfaire/hmmf2022/" className="workdetail__weight" target="_blank" rel="noopener noreferrer">[Link]</a> <br></br>
                    紙は鳴く(2022) | IVRC HISTORY ARCHIVE <a href="https://ivrc.net/archive/%E7%B4%99%E3%81%AF%E9%B3%B4%E3%81%8F2022/" className="workdetail__weight" target="_blank" rel="noopener noreferrer">[Link]</a> <br></br>
                </div>
            </div>
        </section>
    )
    }
    
export default Papersing
